import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=c28898aa&"
import script from "./ReportTable.vue?vue&type=script&lang=js&"
export * from "./ReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports